(function () {
  'use strict';

  var PROP_NAMES = {
    buttons:    'Buttons',
    undercollar:'Undercollar',
    belt:       'Belt',
    sleeve:     'Sleeve lining',
    piping:     'Piping',
    sleevelength:'Fit',
    patches:    'Elbow patches',
  };

  var DISPLAY_NAMES = {
    buttons:    'Buttons',
    undercollar:'Undercollar',
    belt:       'Belt',
    sleeve:     'Sleeve lining',
    piping:     'Piping',
    sleevelength:'Fit',
    patches:    'Elbow patches',
  };

  var state = { buttons: 0, undercollar: 0, belt: 0, sleeve: 0, piping: 0, sleevelength: 0, patches: 0 };
  var selectedSize = null;

  // Embroidery is a real £50 charge now, added as its own cart line (a
  // separate "Embroidery" product) rather than a plain mailto request —
  // it can't be baked into the blazer's own price without doubling every
  // variant, and line item properties never affect price on their own.
  var EMBROIDERY_VARIANT_ID = '58657484865868';
  var embroiderySelected = false;
  var pendingEmbroideryAdd = false;

  function init() {
    var form = document.getElementById('mto-form');
    if (!form) return;

    // Swatch clicks
    form.querySelectorAll('[data-mto-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pick(btn.dataset.mtoSwatch, parseInt(btn.dataset.mtoIdx, 10));
      });
    });

    // Size required. The button starts natively disabled (see markup) —
    // that's the only block that's reliable regardless of script load
    // timing: product-form-component's own submit handling runs off a
    // document-level listener that can be ready before this script's
    // click/submit listeners would be, so relying on preventDefault() here
    // alone can lose that race and let the wrong size through. A disabled
    // submit button can't dispatch a submit event at all, no matter what
    // else has loaded yet.
    //
    // The guard span sits visually on top of the (disabled-but-normal-
    // looking) button so a click still gets a response — it shows the
    // error — instead of silently doing nothing. It goes inert once a
    // size is chosen, letting clicks reach the now-enabled button.
    var sizeWrap = form.querySelector('[data-mto-size-required]');
    var guard = form.querySelector('[data-mto-cta-guard]');
    if (sizeWrap && guard) {
      guard.addEventListener('click', function () {
        showSizeError(sizeWrap);
      });
    }

    // Embroidery toggle
    var embroideryCheckbox = document.getElementById('mto-embroidery-checkbox');
    if (embroideryCheckbox) {
      embroideryCheckbox.addEventListener('change', function () {
        embroiderySelected = embroideryCheckbox.checked;
        var propInput = form.querySelector('input[name="properties[Embroidery]"]');
        if (propInput) {
          var price = embroideryCheckbox.dataset.embroideryPrice || '';
          propInput.value = embroiderySelected ? ('Requested (+' + price + ', confirmed by email)') : 'Not requested';
          // Only sent with the blazer when it's been added - otherwise the
          // cart and checkout listed "Embroidery: Not requested".
          propInput.disabled = !embroiderySelected;
        }
      });
    }

    // Size dropdown
    var trigger  = document.getElementById('mto-size-trigger');
    var dropdown = document.getElementById('mto-size-dropdown');
    if (trigger && dropdown) {
      trigger.addEventListener('click', function () {
        var open = dropdown.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(open));
      });
      dropdown.querySelectorAll('[data-mto-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectSize(btn.dataset.mtoVariantId, btn.dataset.mtoSize, btn);
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('click', function (e) {
        if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Detail accordions
    document.querySelectorAll('[data-mto-detail]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id   = btn.dataset.mtoDetail;
        var body = document.getElementById('mto-detail-body-' + id);
        if (!body) return;
        var open = body.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });

    render();
  }

  function pick(cat, idx) {
    state[cat] = idx;
    render();
  }

  function getValue(cat, idx) {
    var btn = document.querySelector('[data-mto-swatch="' + cat + '"][data-mto-idx="' + idx + '"]');
    return btn ? btn.dataset.mtoValue : '';
  }

  function render() {
    var form = document.getElementById('mto-form');
    if (!form) return;

    // Swatch selected rings
    form.querySelectorAll('[data-mto-swatch]').forEach(function (btn) {
      var cat = btn.dataset.mtoSwatch;
      var idx = parseInt(btn.dataset.mtoIdx, 10);
      btn.classList.toggle('is-selected', state[cat] === idx);
    });

    // Hidden property inputs
    Object.keys(PROP_NAMES).forEach(function (cat) {
      var input = form.querySelector('input[name="properties[' + PROP_NAMES[cat] + ']"]');
      if (input) input.value = getValue(cat, state[cat]);
    });

    // Live selections summary
    var list = document.getElementById('mto-selections-list');
    if (list) {
      list.innerHTML = Object.keys(state).map(function (cat) {
        return '<div class="mto-sel-row">' +
          '<span class="mto-sel-row__key">' + DISPLAY_NAMES[cat] + '</span>' +
          '<span class="mto-sel-row__val">' + getValue(cat, state[cat]) + '</span>' +
          '</div>';
      }).join('');
    }
  }

  function selectSize(variantId, label, activeBtn) {
    var form    = document.getElementById('mto-form');
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput && variantId) idInput.value = variantId;

    selectedSize = label;

    var valEl = document.getElementById('mto-size-val');
    if (valEl) valEl.textContent = label;

    document.querySelectorAll('[data-mto-size]').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn === activeBtn);
    });

    var sizeWrap = form && form.querySelector('[data-mto-size-required]');
    if (sizeWrap) clearSizeError(sizeWrap);

    // A sold-out size can now be picked - that is how the waitlist is reached -
    // so choosing one must NOT arm add-to-basket. The button owns cart state, so
    // the rule lives here rather than in whatever happens to listen afterwards:
    // an unavailable variant can never be submitted, whatever else is loaded.
    var soldOut = !!(activeBtn && activeBtn.dataset.mtoSoldout === 'true');

    var addBtn = form && form.querySelector('.mto-cta');
    if (addBtn) addBtn.disabled = soldOut;
    var guard = form && form.querySelector('[data-mto-cta-guard]');
    // Any size chosen, sold out or not, retires the "select a size" guard: for
    // a sold-out size the add button is hidden and "Join the pre-order
    // waitlist" takes its place, and the guard sitting over it swallowed the
    // tap and said "Please select a size." instead.
    if (guard) guard.classList.add('is-inert');

    // Announced rather than acted on, so the waitlist stays a separate file that
    // can be deleted without touching the configurator.
    document.dispatchEvent(new CustomEvent('mto:size', {
      detail: { label: label, variantId: variantId, soldOut: soldOut }
    }));
  }

  function showSizeError(sizeWrap) {
    sizeWrap.classList.add('is-error');
    var trigger = document.getElementById('mto-size-trigger');
    var error   = document.getElementById('mto-size-error');
    if (trigger) trigger.setAttribute('aria-invalid', 'true');
    if (error) error.hidden = false;
    if (trigger) trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearSizeError(sizeWrap) {
    sizeWrap.classList.remove('is-error');
    var trigger = document.getElementById('mto-size-trigger');
    var error   = document.getElementById('mto-size-error');
    if (trigger) trigger.removeAttribute('aria-invalid');
    if (error) error.hidden = true;
  }

  // Delegated at the document level rather than attached directly to the
  // button node: Shopify's own cart-sync/section-rendering machinery can
  // silently swap the button for a fresh (attribute-identical) node after
  // a cart mutation, which would drop a listener bound to the old node
  // reference — confirmed this happening (a listener attached at page-init
  // time on the button itself stopped firing after a size selection +
  // add-to-cart cycle, while a listener re-attached afterward on a fresh
  // querySelector() worked). Delegation re-resolves the element by
  // selector at click time, so it can't go stale like that.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.mto-cta');
    if (!btn) return;
    pendingEmbroideryAdd = embroiderySelected;
  });

  // Embroidery goes into the cart just before the blazer, not after it.
  // Added afterwards, the drawer first opened with the blazer alone and the
  // Embroidery line popped in half a second later. Added first, the
  // blazer's own add-to-cart opens the drawer with both lines already there
  // (blazer on top, since the newest line is listed first). Runs in the
  // capture phase on window so it gets the submit before the theme's
  // document-level product-form handler.
  var resubmitting = false;

  function jsonPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); });
  }

  function cartSectionIds() {
    return Array.prototype.map.call(
      document.querySelectorAll('cart-items-component'),
      function (el) { return el.dataset.sectionId; }
    ).filter(Boolean).join(',');
  }

  function lineRequestsEmbroidery(item) {
    var value = item.properties && item.properties.Embroidery;
    return !!value && value !== 'Not requested';
  }

  // Same blazer, same size, same details - Embroidery aside.
  function sameBlazer(item, variantId, props) {
    if (String(item.variant_id) !== String(variantId)) return false;
    var a = item.properties || {};
    var keys = {};
    Object.keys(a).concat(Object.keys(props)).forEach(function (k) { keys[k] = true; });
    return Object.keys(keys).every(function (k) {
      return k === 'Embroidery' || (a[k] || '') === (props[k] || '');
    });
  }

  window.addEventListener('submit', function (event) {
    var form = event.target;
    // getAttribute, not form.id: the form has an input named "id" (the
    // variant), which shadows the property.
    if (!form || !form.getAttribute || form.getAttribute('id') !== 'mto-form') return;
    if (resubmitting) {
      resubmitting = false;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    var submitter = event.submitter;
    hideCtaError();

    var data = new FormData(form);
    var variantId = data.get('id');
    var props = {};
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) props[match[1]] = value;
    });
    var wantEmbroidery = embroiderySelected;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // This exact blazer is already in the basket and only the embroidery
        // choice differs (e.g. embroidery was removed in the cart, then asked
        // for again here). Most sizes are one of a kind, so adding it a
        // second time would fail - switch embroidery on that line instead.
        // assets/embroidery-cart-sync.js then adds or drops the €50 line.
        var line = cart.items.filter(function (item) { return sameBlazer(item, variantId, props); })[0];
        if (line && lineRequestsEmbroidery(line) !== wantEmbroidery) {
          pendingEmbroideryAdd = false;
          var properties = {};
          Object.keys(line.properties || {}).forEach(function (k) { properties[k] = line.properties[k]; });
          properties.Embroidery = wantEmbroidery ? props.Embroidery : '';
          return jsonPost('/cart/change.js', { id: line.key, quantity: line.quantity, properties: properties })
            .then(function () { return jsonPost('/cart/update.js', { updates: {}, sections: cartSectionIds() }); })
            .then(function (result) {
              // cart:update both redraws the drawer (and opens it) and wakes
              // the embroidery sync.
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: result,
                  sourceId: 'mto-form',
                  data: { source: 'mto-reconfigure', sections: result.sections, itemCount: result.item_count }
                }
              }));
              return 'done';
            });
        }

        if (!wantEmbroidery) return 'submit';

        // Embroidery goes into the cart just before the blazer, not after it.
        // Added afterwards, the drawer first opened with the blazer alone and
        // the Embroidery line popped in half a second later. Added first, the
        // blazer's own add-to-cart opens the drawer with both lines already
        // there. Runs in the capture phase on window so it gets the submit
        // before the theme's document-level product-form handler.
        var body = new FormData();
        body.append('id', EMBROIDERY_VARIANT_ID);
        body.append('quantity', '1');
        return fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (result) {
            if (result.status) throw result;
            // Already in: the old add-after path must not add a second one,
            // and it is taken back out again if the blazer itself then fails.
            pendingEmbroideryAdd = false;
            embroideryAddedFor = true;
          })
          .catch(function (err) {
            // Couldn't add it first - fall back to adding it after the blazer.
            console.error('Embroidery add-on failed to add to cart', err);
          })
          .then(function () { return 'submit'; });
      })
      .catch(function (err) {
        console.error('Add to basket pre-check failed', err);
        return 'submit';
      })
      .then(function (next) {
        if (next !== 'submit') return;
        resubmitting = true;
        if (form.requestSubmit) form.requestSubmit(submitter || undefined);
        else form.submit();
      });
  }, true);

  // Shown under the button when the basket refuses the blazer - before this
  // the tap simply did nothing. The usual reason: that size has one piece and
  // it is already in the basket.
  function ctaErrorEl() {
    var el = document.getElementById('mto-cta-error');
    if (el) return el;
    var wrap = document.querySelector('.mto-cta-wrap');
    if (!wrap) return null;
    el = document.createElement('p');
    el.id = 'mto-cta-error';
    el.className = 'mto-cta-error';
    el.setAttribute('role', 'alert');
    el.hidden = true;
    wrap.insertAdjacentElement('afterend', el);
    return el;
  }
  function hideCtaError() {
    var el = document.getElementById('mto-cta-error');
    if (el) el.hidden = true;
  }
  document.addEventListener('cart:error', function (event) {
    var detail = event.detail || {};
    if (detail.sourceId && detail.sourceId !== 'mto-form') return;
    var el = ctaErrorEl();
    if (!el) return;
    var info = detail.data || {};
    var text = String(info.description || info.message || '');
    el.textContent = /cart|basket|quantity|available|stock/i.test(text)
      ? 'This size is already in your basket and there are no more available right now.'
      : (text || 'Something went wrong. Please try again.');
    el.hidden = false;
  });

  // The blazer didn't make it into the cart (e.g. it sold out a moment ago):
  // take the Embroidery just added for it back out so it isn't left alone.
  var embroideryAddedFor = false;
  document.addEventListener('cart:error', function () {
    if (!embroideryAddedFor) return;
    embroideryAddedFor = false;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var line = cart.items.filter(function (item) {
          return String(item.variant_id) === EMBROIDERY_VARIANT_ID;
        })[0];
        if (!line) return;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity - 1 })
        });
      });
  });
  document.addEventListener('cart:update', function (event) {
    var data = event.detail && event.detail.data;
    if (data && data.source === 'product-form-component' && !data.didError) embroideryAddedFor = false;
  });

  // Fires on every cart change theme-wide (quantity edits in the drawer
  // included), so this only acts when pendingEmbroideryAdd is set (by a
  // real submit click on this exact form) and the event is genuinely the
  // blazer add-to-cart succeeding — checked via source + productId, not
  // just "a cart update happened somewhere".
  document.addEventListener('cart:update', function (event) {
    if (!pendingEmbroideryAdd) return;

    var data = event.detail && event.detail.data;
    if (!data || data.didError || data.source !== 'product-form-component') return;

    var productForm = document.querySelector('product-form-component');
    if (!productForm || data.productId !== productForm.dataset.productId) return;

    pendingEmbroideryAdd = false;

    var sectionIds = Array.prototype.map.call(
      document.querySelectorAll('cart-items-component'),
      function (el) { return el.dataset.sectionId; }
    ).filter(Boolean);

    var body = new FormData();
    body.append('id', EMBROIDERY_VARIANT_ID);
    body.append('quantity', '1');
    sectionIds.forEach(function (id) { body.append('sections', id); });

    fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (result) {
        if (result.status) {
          console.error('Embroidery add-on failed to add to cart', result);
          return;
        }
        // Re-broadcast so the drawer/cart-icon refresh with the new line,
        // reusing the theme's own existing cart:update listeners.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(EMBROIDERY_VARIANT_ID),
            data: { source: 'mto-embroidery', sections: result.sections }
          }
        }));
      })
      .catch(function (err) {
        console.error('Embroidery add-on failed to add to cart', err);
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
